import { gql } from '@apollo/client';

export const SIGNUP_MUTATION = gql`
mutation createUser($input: NewUserInput!) {
        createUser(input: $input) {
            id
            newUser
            firstName
            lastName
            username
            jobTitle
            email
            phoneNumber
            companyName
            country
            createdAt
            password
            passwordConfirm
            acceptTerms
            role
            idvHostedUrl
            userPreferences {
                theme
                landingPage
                avatar
            }
        }
    }
`;
